import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../services/firebase";
import { ref, set } from "firebase/database";
import { useNavigate } from "react-router-dom";
import "./AdminRegister.css"; // ✅ updated CSS file

function AdminRegister() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleAdminRegister = async () => {
    if (!name || !email || !username || !password) {
      setError("Please fill in all fields.");
      return;
    }

    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      const user = result.user;

      const userData = {
        name,
        email,
        username,
        uid: user.uid,
        createdAt: new Date().toISOString(),
      };

      await set(ref(db, `users/${user.uid}`), userData);
      await set(ref(db, `admins/${user.uid}`), true);

      localStorage.setItem("user", JSON.stringify(user));
      navigate("/dashboard");
    } catch (err) {
      setError("Registration failed: " + err.message);
    }
  };

  return (
    <div className="ar-container">
      <h2 className="ar-title">Admin Registration</h2>

      <input
        className="ar-input"
        type="text"
        placeholder="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        className="ar-input"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        className="ar-input"
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        className="ar-input"
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button className="ar-btn" onClick={handleAdminRegister}>
        Register as Admin
      </button>

      {error && <p className="ar-error">{error}</p>}

      <p className="ar-link">
        <a href="/admin-login">Already an admin? Login</a>
      </p>
    </div>
  );
}

export default AdminRegister;
